import banner  from "./banner";
import page  from "./page";
import event  from "./event";

export default [
  banner,
  page,
  event
]
